import React, { useState, useContext } from 'react';

import cookie from 'react-cookies';
import ReactModal from 'react-modal';

/** components */
import CustomPlaidLink from './CustomPlaidLink';

import Close from '../../assets/images/close.svg';

/** images */
import PlaidImg from '../../assets/images/plaid.png';
import TenantConfig from '../../config';

/** context */
import { UserContext } from '../../context/UserContext';
import { useBoolean } from '../../hooks/useBoolean';

/** service */
import { getPlaidLinkToken } from '../../service/api';

const customStyles = {
  content: {
    maxWidth: '600px',
    maxHeight: '500px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 auto',
    padding: '15px, 50px 50px 50px',
  },
};

const PlaidBank = ({ handleContinue, setPlaidState, closeTimes, setCloseTimes }) => {
  const [token, setToken] = useState(null);
  const [error, setError] = useState('');
  const { setLoading } = useContext(UserContext);
  const oauth_state_id = cookie.load('oauth_state_id');
  const receivedRedirectUri = cookie.load('receivedRedirectUri');
  const plaidModal = useBoolean();

  // generate a link_token
  React.useEffect(() => {
    async function createLinkToken() {
      const res = await getPlaidLinkToken();
      setToken(res.data.linkToken);
      localStorage.setItem('link_token', JSON.stringify(res.data.linkToken));
    }

    if (oauth_state_id) {
      const linkTokenObj = localStorage.getItem('link_token');
      const linkToken = JSON.parse(linkTokenObj);
      setToken(linkToken);
    } else {
      createLinkToken();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="bank-information">
      <h1 className="title">{TenantConfig.plaidPage.title}</h1>
      <h3
        className="subtitle"
        dangerouslySetInnerHTML={{
          __html: TenantConfig.plaidPage.subTitle,
        }}
      />
      <div className="plaid-options">
        <div className="option-item">
          <div>
            <a onClick={plaidModal.toggle} href="#">
              Learn more about Plaid
            </a>
          </div>
          {token && (
            <CustomPlaidLink
              token={token}
              handleContinue={handleContinue}
              setPlaidState={setPlaidState}
              setLoading={setLoading}
              setError={setError}
              receivedRedirectUri={oauth_state_id ? receivedRedirectUri : undefined}
              buttonText={'Start Plaid'}
              buttonClassName={'plaid-btn'}
              closeTimes={closeTimes}
              setCloseTimes={setCloseTimes}
            />
          )}
          <img src={PlaidImg} alt="" className="plaid-img" />
        </div>
      </div>
      {error && <div className="error-text">{error}</div>}
      <ReactModal style={customStyles} isOpen={plaidModal.state}>
        <div className="modal-close" onClick={plaidModal.off}>
          <img src={Close} alt="close" />
        </div>
        <div className="modal-description">
          <p
            className="description"
            dangerouslySetInnerHTML={{
              __html: TenantConfig.plaidPage.modalContent,
            }}
          />
        </div>
      </ReactModal>
    </div>
  );
};

export default PlaidBank;
